import { Controller } from "@hotwired/stimulus";
import $ from "jquery";
import "../../../vendor/assets/javascripts/parsley/fr";
import {
  initDateAfterOrEqualToValidator,
  initDateBeforeOrEqualToValidator,
  initExcludedFromValidator,
  initRequiredIfValidator,
  standardErrorsContainer,
  initUniqueValueValidator,
} from "../utils/parsley_validators_utils";

/**
 * Generic controller for form validation with the parsleyjs library
 * Here we set/override configuration options applicable to any such form
 */
export default class extends Controller {
  static targets = ["trixEditor"];

  static values = {
    customValidators: Array,
  };

  initialize() {
    $(this.element).parsley({
      ...standardErrorsContainer(),
    });
    this._setFieldValidationTrigger();
    this._initCustomValidators();

    if (this.hasTrixEditorTarget) {
      this.element.dataset.parsleyExcluded = this._parsleyExcludedSelector();
    }
  }

  disconnect() {
    $(this.element).parsley().destroy();
  }

  validate() {
    $(this.element).parsley().validate();
  }

  _setFieldValidationTrigger() {
    [...this.element.elements]
      .filter((element) => !element.dataset.parsleyTrigger)
      .forEach((element) => {
        element.dataset.parsleyTrigger = "blur";
      });
  }

  _parsleyExcludedSelector() {
    const trixToolbarLinkInput = '.link_url_fields > input[type="url"][name="href"]';
    let parsleyExcludedSelector = trixToolbarLinkInput;

    const formExcludedElements = this.element.dataset.parsleyExcluded;
    if (formExcludedElements) {
      parsleyExcludedSelector += `,${formExcludedElements}`;
    }

    return parsleyExcludedSelector;
  }

  _initCustomValidators() {
    this.customValidatorsValue.forEach((customValidator) => {
      if (!window.Parsley.hasValidator(customValidator)) {
        this._initCustomValidator(customValidator);
      }
    });
  }

  _initCustomValidator(customValidator) {
    if (customValidator === "dgte") {
      initDateAfterOrEqualToValidator();
    } else if (customValidator === "requiredIf") {
      initRequiredIfValidator();
    } else if (customValidator === "excludedFrom") {
      initExcludedFromValidator();
    } else if (customValidator === "dlte") {
      initDateBeforeOrEqualToValidator();
    } else if (customValidator === "uniqueValue") {
      initUniqueValueValidator();
    }
  }
}
